import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import adminService from '@/services/setting.service'
import AuthService from '@/services/auth.service'
let activityTimer = null

export function useAdminCommon() {
  const store = useStore()
  const router = useRouter()

  function com_UpdateTokenAndTime(_token) {
    const current = new Date()
    localStorage.removeItem('jwt_token')
    localStorage.removeItem('tkutim')
    localStorage.setItem('jwt_token', 'cookie-session')
    localStorage.setItem('tkutim', current.getTime())
  }

  async function com_setLoginData(param) {
    if (param.jwt_token) {
      return AuthService.getProfile().then(
        (response) => {
          localStorage.setItem('jwt_token', 'cookie-session')
          store.dispatch('changLoginStatus', true)
          store.dispatch('setUser', response.data.result.user)
          com_CheckVisitActivityAndTokenStatus()
          if (param.redirect_url) {
            router.push(param.redirect_url)
          }
        },
        async (error) => {
          await AuthService.logout().catch(() => {})
          let alertmessage = ''
          for (const prop in error.response) {
            alertmessage += ' ' + error.response[prop]
          }
          localStorage.removeItem('jwt_token')
          store.dispatch('setUser', null)
          store.dispatch('changLoginStatus', false)
          com_CheckVisitActivityAndTokenStatus(false)
          console.log(param.redirect_url)
          console.log(alertmessage)
          router.push({ name: 'login' })
        }
      )
    } else {
      await AuthService.logout().catch(() => {})
      store.dispatch('setServerWSData', {})
      store.dispatch('setWsReloaded', true)
      store.dispatch('setWsConnectOpenStatus', false)
      localStorage.removeItem('jwt_token')
      store.dispatch('setUser', null)
      store.dispatch('changLoginStatus', false)
      com_CheckVisitActivityAndTokenStatus(false)
      store.dispatch('setWsServerLoadConnection', {})
      if (param.redirect_url) {
        router.push(param.redirect_url)
      }
    }
  }

  function com_setPanelData(param) {
    store.dispatch('setPanelData', param.panel_settings)
    const loginparam = {
      jwt_token: localStorage.getItem('jwt_token'),
    }
    if (loginparam.jwt_token) com_setLoginData(loginparam)
  }

  function com_CheckVisitActivityAndTokenStatus(startInterval = true) {
    if (activityTimer !== null) clearInterval(activityTimer)
    activityTimer = null
    localStorage.removeItem('visitActvityProcess')
    const maxIdleTime = process.env.VUE_APP_MAXIDLETIME
    const intervalTime = process.env.VUE_APP_CHECKACTIVITYINTERVALTIME
    const tokenRefreshTime = process.env.VUE_APP_TOKENREFRESHTIME

    if (startInterval) {
      activityTimer = setInterval(function () {
        const lastActivityTime = localStorage.getItem('lastActivityTime')
        const lasttokenUpdateTime = localStorage.getItem('tkutim')
        const current = new Date()
        const totalIdleTime = parseInt(lastActivityTime) + parseInt(maxIdleTime)
        if (totalIdleTime < current.getTime()) {
          const loginparam = {
            jwt_token: '',
            redirect_url: { name: 'login' },
          }
          com_setLoginData(loginparam)
        } else {
          const nextTokenRefreshTime =
            parseInt(lasttokenUpdateTime) + parseInt(tokenRefreshTime)
          if (current.getTime() >= nextTokenRefreshTime) {
            com_RefreshToken()
          }
        }
      }, intervalTime)
    }
  }

  function com_SetLastActivityTime() {
    const current = new Date()
    localStorage.setItem('lastActivityTime', current.getTime())
  }

  function com_CheckUserType(param, type = false) {
    const data = JSON.parse(param)
    if (data.includes(0)) {
      return data.includes(0)
    }
    return data.includes(type)
  }

  function com_RefreshToken() {
    adminService
      .getRefreshToken()
      .then(function (response) {
        com_UpdateTokenAndTime(response.token)
      })
      .catch(function (error) {
        let alertmessage = ''
        for (const prop in error.response) {
          alertmessage += ' ' + error.response[prop]
        }
        console.log(alertmessage)
        com_errorHandel(error)
      })
  }

  function com_errorHandel(error) {
    const errorData = error?.response?.data || error?.data || {}
    const isAuthFailure =
      errorData?.success === false ||
      error?.response?.status === 401 ||
      error?.response?.status === 419

    if (isAuthFailure) {
      const loginparam = {
        jwt_token: '',
        redirect_url: { name: 'login' },
      }
      com_setLoginData(loginparam)
    }
  }

  function com_displayDateFormat(date, isObject = true) {
    if (
      !date ||
      date === '0000-00-00' ||
      date === '0000-00-00 00:00:00'
    ) {
      return isObject ? { date: '', hour: 0 } : '—'
    }

    const normalizedDate =
      typeof date === 'string' && /^\d{4}-\d{2}-\d{2}\s/.test(date)
        ? date.replace(' ', 'T')
        : date
    const newDate = new Date(normalizedDate)
    if (Number.isNaN(newDate.getTime())) {
      return isObject ? { date: String(date), hour: 0 } : String(date)
    }

    let resultArr = []
    const convertedDate =
      newDate.getFullYear() +
      '-' +
      ('0' + (newDate.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + newDate.getDate()).slice(-2)

    const convertedHour = newDate.getHours()
    if (isObject) {
      resultArr = { date: convertedDate, hour: convertedHour }
    } else {
      const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ]
      const modernDate =
        ('0' + newDate.getDate()).slice(-2) +
        ' ' +
        monthNames[newDate.getMonth()] +
        ' ' +
        newDate.getFullYear()
      const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(String(date).trim())

      if (isDateOnly) {
        resultArr = modernDate
      } else {
        const hour = newDate.getHours()
        const displayHour = hour % 12 || 12
        const minutes = ('0' + newDate.getMinutes()).slice(-2)
        const period = hour >= 12 ? 'PM' : 'AM'
        resultArr = `${modernDate}\n${displayHour}:${minutes} ${period}`
      }
    }
    return resultArr
  }

  function com_currentDateTime(format = '', time = '') {
    const monthShortNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]

    const current = new Date()
    let date
    let timePart = time

    if (format == 'dmy') {
      date =
        ('0' + current.getDate()).slice(-2) +
        ' ' +
        monthShortNames[current.getMonth()] +
        ', ' +
        current.getFullYear()
    } else {
      date =
        current.getFullYear() +
        '-' +
        ('0' + (current.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + current.getDate()).slice(-2)
    }

    if (timePart == '' || timePart == 'yes') {
      timePart =
        ('0' + current.getHours()).slice(-2) +
        ':' +
        ('0' + current.getMinutes()).slice(-2) +
        ':' +
        ('0' + current.getSeconds()).slice(-2)
    } else {
      timePart = ''
    }

    return date + ' ' + timePart
  }

  function com_modifyDateTime(no_of_days = 0, date = '') {
    let newDate
    if (date != '') {
      newDate = new Date(date)
    } else {
      newDate = new Date()
    }

    if (parseInt(no_of_days) != 0) {
      newDate.setDate(newDate.getDate() + parseInt(no_of_days))
    }

    return (
      newDate.getFullYear() +
      '-' +
      ('0' + (newDate.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + newDate.getDate()).slice(-2) +
      ' ' +
      ('0' + newDate.getHours()).slice(-2) +
      ':' +
      ('0' + newDate.getMinutes()).slice(-2) +
      ':' +
      ('0' + newDate.getSeconds()).slice(-2)
    )
  }

  function validateNumberField(value, setterOrState, model_name, maxDigit, warnState) {
    const numericValue = value.replace(/\D/g, '')
    if (numericValue.length > 0 && numericValue[0] === '0') {
      if (typeof setterOrState === 'function') {
        setterOrState('')
      } else {
        setterOrState[model_name] = ''
      }
      if (warnState) {
        warnState[model_name] = 'First digit cannot be zero'
      }
      return
    }

    if (numericValue.length > maxDigit) {
      const trimmed = numericValue.slice(0, maxDigit)
      if (typeof setterOrState === 'function') {
        setterOrState(trimmed)
      } else {
        setterOrState[model_name] = trimmed
      }
      if (warnState) {
        warnState[model_name] = `Maximum ${maxDigit} digits allowed`
      }
    } else {
      if (typeof setterOrState === 'function') {
        setterOrState(numericValue)
      } else {
        setterOrState[model_name] = numericValue
      }
      if (warnState) {
        warnState[model_name] = false
      }
    }
  }

  function com_pageNotFound() {
    router.push({ name: 'pagesnotfound' })
  }

  function extractErrorMessage(error, fallback = 'Something went wrong') {
    if (!error) return fallback
    const data = error?.response?.data || error?.data || error
    if (typeof data === 'string') return data
    if (data?.message) return data.message
    if (data?.error) return typeof data.error === 'string' ? data.error : fallback
    if (data?.errors) {
      const parts = []
      for (const key in data.errors) {
        const val = data.errors[key]
        parts.push(Array.isArray(val) ? val.join(' ') : String(val))
      }
      if (parts.length) return parts.join(' ')
    }
    return fallback
  }

  return {
    store,
    router,
    com_UpdateTokenAndTime,
    com_setLoginData,
    com_setPanelData,
    com_CheckVisitActivityAndTokenStatus,
    com_SetLastActivityTime,
    com_CheckUserType,
    com_RefreshToken,
    com_errorHandel,
    com_displayDateFormat,
    com_currentDateTime,
    com_modifyDateTime,
    validateNumberField,
    com_pageNotFound,
    extractErrorMessage,
  }
}
